/* eslint-disable no-restricted-imports */
import React, { Suspense } from 'react';
import type { ListRange, VirtuosoHandle, VirtuosoProps } from 'react-virtuoso';

import Loader from '@/components/Loader';

const LazyVirtuoso = React.lazy(() => {
  return import(/* webpackChunkName: "react-virtuoso" */ 'react-virtuoso').then((exports) => {
    return { default: exports.Virtuoso };
  });
});

const BaseList = React.forwardRef(
  (props: VirtuosoProps<any, any>, ref: React.Ref<VirtuosoHandle>) => {
    return (
      <Suspense fallback={<Loader />}>
        <LazyVirtuoso ref={ref} {...props} />
      </Suspense>
    );
  },
);

export type { ListRange, VirtuosoHandle };
export default BaseList;
